module.exports = __webpack_public_path__ + "img/iu.a699f6af.png";